export default "__VITE_ASSET__CqTSWWWZ__"